import { Component, OnInit, TemplateRef } from '@angular/core';
import { HomeService, ContextService } from '../services';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers: [ BsModalService ]
})
export class SearchComponent implements OnInit {

  query:string;
  niveau:number;
  type:number;
  classe:number;
  editeur:number;
  discipline:number;
  context: string;
  context_route: string;
  niveaux:Array<any>;
  types:Array<any> = [];
  classes:Array<any>;
  editeurs:Array<any>;
  disciplines:Array<any>;
  modalRef: BsModalRef;
   stringinvalid:boolean=false;

  constructor(
    private homeService: HomeService,
    private contextService: ContextService,
    private router: Router,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    
  ) { }

  ngOnInit() {
    console.log(this.contextService.getContext());
    this.homeService.getAllEditeurs()
      .subscribe(editeurs => {
        this.editeurs = editeurs;
    });

    this.homeService.getAllNiveaux()
      .subscribe(niveaux => {
        this.niveaux = niveaux;
    });

    this.homeService.getAllDisciplines()
      .subscribe(disciplines => {
        this.disciplines = disciplines;
    });

    this.homeService.getAllClasses()
      .subscribe(classes => {
        this.classes = classes;
    });

    this.homeService.getAllTypes()
      .subscribe(types => {
        this.types = types;
        this.types = this.types.filter( t => t.publication == true );
    });

    this.context = this.contextService.getContext();
    if(this.context == 'B2C'){
      this.context_route = '/familles';
    } else {
      this.context_route = '';
    }

    this.router.events.subscribe((ev:any) => {
         if (ev instanceof NavigationEnd ) {
          let url =ev.url.split("/");
          this.context = (url[1] && url[1]=='familles') ? 'B2C':'B2B';
          this.context_route=(this.context=='B2B')?'':'/familles';
        
        }
          
     });

  }

  onChangeNiveau(idNiveau) {
     this.homeService.getClassesByNiveau(idNiveau).subscribe(classes => {
        console.log(classes)
        this.classes = classes;
    });

     this.homeService.getDisciplinesByNiveau(idNiveau).subscribe(disciplines => {
      
        this.disciplines = disciplines;
    });

  }

  onSubmit(data){
  	 this.stringinvalid=false
  
    // this.editeur = null;
    // if(+this.editeur == 0) this.editeur = undefined;
    // if(+this.editeur == 0) this.editeur = undefined;
    // if(+this.editeur == 0) this.editeur = undefined;
    // if(+this.editeur == 0) this.editeur = undefined;
    if(this.query != '' && this.query != undefined){
        if(this.query.length<2){
       this.stringinvalid=true;
       return;
    }
      sessionStorage.setItem('search_request_hachette_kne', JSON.stringify({
        marche: this.context,
        plaintext: this.query,
        editeur: [+this.editeur],
        niveau: [+this.niveau],
        classe: [+this.classe],
        typeArticle: [+this.type],
        discipline: [+this.discipline]
      }));
    } else {
      sessionStorage.setItem('search_request_hachette_kne', JSON.stringify({
        marche: this.context,
        editeur: [+this.editeur],
        niveau: [+this.niveau],
        classe: [+this.classe],
        typeArticle: [+this.type],
        discipline: [+this.discipline]
      }));
    }

    // console.log(sessionStorage.getItem('search_request_hachette_kne'));
    
    if(this.query != '' && this.query != undefined){

      this.router.navigate([ this.context_route + '/recherche/' + this.query ]);
    } else {
      this.router.navigate([ this.context_route + '/recherche' ]);
    }

    this.modalRef.hide();

  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/search/search.component.ts